import { CREATE_TICKET } from 'modules/v2/store/constants';

export const createTicket = (message) => ({
  type: CREATE_TICKET,
  payload: {
    message,
  },
});
